import { isTenantOwnerAdmin } from "utils/isTenantOwnerAdmin"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { Map, GoogleApiWrapper } from "google-maps-react"
import { InfoWindow, Marker } from "@react-google-maps/api"

import { connect } from "react-redux"

import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Button,
  UncontrolledTooltip,
  Nav,
  NavItem,
  TabContent,
  TabPane,
  NavLink,
  Form,
  Table,
  Badge,
  ModalHeader,
  ModalBody,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { useNavigate, useLocation } from "react-router"
import { defaultLat, defaultLng, googleAPIKeys } from "common/utils"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import {
  deleteBranch,
  getAllBranchsList,
  updateBranchStatus,
} from "store/actions/branchsActions"
import { getCurrentSubscription } from "store/actions/subscriptionAction"
import {
  getBranchLimitExceededMessage,
  isBranchLimitReached,
  resolveTenantBranchLimit,
} from "utils/tenantBranchLimit"
import DeleteModal from "components/Common/DeleteModal"
import Paginations from "components/Common/Paginations"
import isPermissionEnabled, {
  getSubPermissions,
} from "common/isPermissionEnabled"
import { showAlert } from "store/reducers/alertReducer"
import { ShimmerThumbnail } from "react-shimmer-effects"
import { Modal } from "reactstrap"
import UpdateOpeningHours from "./UpdateOpeningHours"
import Select from "react-select"
import placeholderImage from "assets/images/placeholderImage.png"
import { useTranslation } from "react-i18next"
import { Formik } from "lib/formik"
import CloneBranch from "./CloneBranch"
import Switch from "components/Shared/Switch"
import DataExportDropdown from "components/Shared/DataExportDropdown"
import DownloadCSV from "components/Shared/DownloadCSV"
import DownloadXLSX from "components/Shared/DownloadXLSX"
import { pdfDownload } from "helpers/api_helper"
import { EXPORT_DATA } from "helpers/url_helper"
import ConfirmModal from "components/Common/ConfirmModal"
const LoadingContainer = () => <div>Loading...</div>
const ADD_BRANCH_BTN_WRAPPER_ID = "add-branch-btn-wrapper"

const MapsGoogle = props => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = t("Branches ")

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const pageNumber = parseInt(searchParams.get("page")) || 1

  const [searchTerm, setSearchTerm] = useState(searchParams.get("search") || "")
  const [center, setCenter] = useState({ lat: defaultLat, lng: defaultLng })
  const [showBranch, setShowBranch] = useState(true)
  const [status, setStatus] = useState(2)
  const [selectedLocationId, setSelectedLocationId] = useState(null)
  const [itemIdToDelete, setItemIdToDelete] = useState(null)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [zoom, setZoom] = useState(10)
  const [activeTab, setActiveTab] = useState("1")
  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const [branchToUpdate, setBranchToUpdate] = useState(null)

  const [modal, setModal] = useState(false)
  const toggle = () => setModal(!modal)

  const { userRole, accountType, accountScope } = useSelector(state => state.Login)
  const { currentSubscription } = useSelector(state => state.Subscription)
  const [branchsPermissions, setBranchsPermissions] = useState({
    list: null,
    create: null,
    edit: null,
    delete: null,
    clone: null,
  })
  const [branchSubPermissions, setBranchSubPermissions] = useState({})
  const [cloneModal, setCloneModal] = useState(false)
  const [cloneBranchId, setCloneBranchId] = useState(null)
  const [selectedId, setSelectedId] = useState(null)
  const toggleCloneModal = () => {
    cloneModal && setCloneBranchId(null)
    setCloneModal(!cloneModal)
  }

  // FIRST CHECK PERMISSION, IF DOES'T HAVE THEN REDIRECT TO DASHBOARD
  useEffect(() => {
    const isPermissionList = isPermissionEnabled(
      userRole,
      5,
      "branchLocations_1",
      accountType
    )
    const isPermissionCreate = isPermissionEnabled(
      userRole,
      5,
      "branchLocations_2",
      accountType
    )
    const isPermissionEdit = isPermissionEnabled(
      userRole,
      5,
      "branchLocations_3",
      accountType
    )

    // get sub permissions array
    const subPermissionsEdit = getSubPermissions(
      userRole,
      5,
      "branchLocations_3",
      accountType
    )

    // set sub permissions array data state
    setBranchSubPermissions(subPermissionsEdit)

    // const isPermissionDelete = isPermissionEnabled(
    //   userRole,
    //   5,
    //   "branchLocations_4"
    // )
    if (!isPermissionList) {
      navigate("/dashboard")
    }
    setBranchsPermissions({
      list: isPermissionList,
      create: isPermissionCreate,
      edit: isPermissionEdit,
      // delete: isPermissionDelete,
    })
  }, [userRole])

  const {
    loading,
    isLoading,
    totalPages,
    currentPage,
    itemsPerPage,
    branchsList,
    isUpdating,
    totalCount,
  } = useSelector(state => state.Branchs)
  const maxBranches = resolveTenantBranchLimit(currentSubscription)
  const branchLimitReached = isBranchLimitReached(totalCount, maxBranches)
  const branchLimitMessage = branchLimitReached
    ? getBranchLimitExceededMessage(maxBranches, t)
    : ""

  const handleAddBranch = () => {
    if (branchLimitReached) {
      return
    }
    navigate("/branches/add")
  }

  const handleCloneBranchClick = branchId => {
    if (branchLimitReached) {
      dispatch(showAlert({ text: branchLimitMessage, type: "error" }))
      return
    }
    toggleCloneModal()
    setCloneBranchId(branchId)
  }

  // get all branchs list
  useEffect(() => {
    getAllBranchLists()
    if (accountScope !== "super_admin") {
      dispatch(getCurrentSubscription())
    }
  }, [])

  const getAllBranchLists = () => {
    const payload = {
      perPage: itemsPerPage,
      pageNo: pageNumber,
      status: 2,
      orderBy: 1,
      keyword: "",
    }
    dispatch(getAllBranchsList(payload))
  }

  const handleSearchChange = e => {
    setSearchTerm(e.target.value)
    const searchParams = new URLSearchParams()
    searchParams.set("search", e.target.value)
    navigate(`/branches?${searchParams.toString()}`)
  }

  const handleStatusFilter = value => {
    setStatus(parseInt(value))
  }

  const handleReset = () => {
    setSearchTerm("")
    setStatus(2)
    const payload = {
      perPage: itemsPerPage,
      pageNo: 1,
      status: 2,
      orderBy: 1,
      keyword: "",
    }
    dispatch(getAllBranchsList(payload))
    navigate(`/branches`)
  }

  const handleEditBranch = id => {
    navigate(`/branches/edit?id=${id}`)
  }

  useEffect(() => {
    // Get user's current location
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        position => {
          setCenter({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          })
        },
        error => {
          console.error("Error getting user location:", error)
        }
      )
    } else {
      console.error("Geolocation is not supported by this browser.")
    }
  }, [])

  const handleCheckboxChange = () => {
    setShowBranch(prevShowBranch => !prevShowBranch)
  }

  const handleDelete = () => {
    const payload = {
      id: itemIdToDelete,
      status: "2", // 2 FOR DELETE
    }
    dispatch(deleteBranch({ ...payload, setShowDeleteModal }))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  const filteredLocations = (branchsList || []).filter(location => {
    const query = String(searchTerm || "").toLowerCase()
    const matchesSearch =
      !query ||
      [location?.name, location?.nameAr, location?.branchId]
        .filter(value => value != null && value !== "")
        .some(value => String(value).toLowerCase().includes(query))

    const matchesStatus =
      status === 2 || // All
      location.status === parseInt(status) // Active (1) or Deactive (0)
    return matchesSearch && matchesStatus
  })

  const onPageChange = page => {
    const payload = {
      perPage: itemsPerPage,
      pageNo: page,
      status: 2,
      orderBy: 1,
      keyword: "",
    }
    dispatch(getAllBranchsList(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          navigate(`/branches?page=${page}`)
        }
      })
      .catch(error => {})
  }

  useEffect(() => {
    setTimeout(() => {
      setCenter({
        lat: 24.80349,
        lng: 46.694417,
      })
    }, 2000)
  }, [])
  useEffect(() => {
    setTimeout(() => {
      setCenter({
        lat: 24.80349,
        lng: 46.694417,
      })
    }, 5000)
  }, [])

  const [isShowAllBranch, setIsShowAllBranch] = useState(false)

  useEffect(() => {
    // Calculate bounds for all markers
    const bounds = new google.maps.LatLngBounds()
    filteredLocations.forEach(({ latitude, longitude }) => {
      bounds.extend(new google.maps.LatLng(latitude, longitude))
    })

    // Set center and zoom level to fit all markers within the map view
    if (filteredLocations.length > 0 && !isShowAllBranch) {
      setIsShowAllBranch(true)
      // setCenter(bounds.getCenter().toJSON());
      setZoom(calculateZoomLevel(bounds, 500, 500)) // Adjust the padding as needed
    }
  }, [props.google, filteredLocations, isShowAllBranch])

  const calculateZoomLevel = (bounds, width, height) => {
    const WORLD_DIM = { height: 256, width: 256 }
    const ZOOM_MAX = 21 // Maximum zoom level

    const ne = bounds.getNorthEast()
    const sw = bounds.getSouthWest()

    const latFraction = Math.abs(ne.lat() - sw.lat()) / 180
    const lngFraction = Math.abs(ne.lng() - sw.lng()) / 360

    const latZoom = Math.floor(
      Math.log(height / WORLD_DIM.height / latFraction) / Math.LN2
    )
    const lngZoom = Math.floor(
      Math.log(width / WORLD_DIM.width / lngFraction) / Math.LN2
    )

    return Math.min(latZoom, lngZoom, ZOOM_MAX)
  }

  const handleTabChange = tab => {
    if (activeTab !== tab) {
      setActiveTab(tab)
      setSearchTerm("")
    }
  }
  const [activeMarker, setActiveMarker] = useState(null)

  const handleMarkerClick = id => {
    setActiveMarker(id)
  }

  const handleInfoWindowClose = () => {
    setActiveMarker(null)
  }
  
  const exportToCSV = async () => {
    const payload = {
      status: status,
      keyword: searchTerm || "",
      type: "BRANCH",
      exportType: "csv",
    }

    const response = await pdfDownload(EXPORT_DATA, payload)
    if (response) {
      const csvData = response
      DownloadCSV(csvData, t("Branches"))
    }
  }

  const handleExcelDownload = async () => {
    const payload = {
      status: status,
      keyword: searchTerm || "",
      type: "BRANCH",
      exportType: "xlsx",
    }

    const response = await pdfDownload(EXPORT_DATA, payload)
    if (response) {
      const xlsxData = response
      DownloadXLSX(xlsxData, t("Branches"))
    }
  }

  function convertToAMPM(time24) {
    const [hours, minutes] = time24.split(":")
    let suffix = "AM"
    let hour = parseInt(hours, 10)

    if (hour >= 12) {
      suffix = "PM"
      if (hour > 12) {
        hour -= 12
      }
    }
    if (hour === 0) {
      hour = 12 // 12 AM
    }

    return `${hour}:${minutes} ${suffix}`
  }

  const handleEnableBranch = (id, status) => {
    setSelectedId(id)
    const payload = {
      id,
      status: status === 1 ? "0" : "1",
    }
    dispatch(updateBranchStatus(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  return (
    <React.Fragment>
      <div className="page-content locations_page">
        <div className="container-fluid">
          <Breadcrumbs />

          {loading ? (
            <Row>
              <Card>
                <CardBody>
                  <ShimmerThumbnail height={700} rounded />
                </CardBody>
              </Card>
            </Row>
          ) : (
            <Card>
              <CardBody>
                <Row className="position-relative">
                  <Nav tabs className="mt-2">
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={`nav-link ${
                          activeTab === "1" ? "active" : ""
                        }`}
                        onClick={() => {
                          handleTabChange("1")
                        }}
                      >
                        <span>{t("Branches List")}</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={`nav-link ${
                          activeTab === "2" ? "active" : ""
                        }`}
                        onClick={() => {
                          handleTabChange("2")
                        }}
                      >
                        <span>{t("Map")}</span>
                      </NavLink>
                    </NavItem>
                  </Nav>

                  <TabContent activeTab={activeTab} className="p-3">
                    <TabPane tabId="1">
                      <Col>
                        <CardTitle className="d-flex align-items-center justify-content-between">
                          <p className="mx-2" key={language}>
                            {t("Branches")}(
                            <span
                              style={{
                                // color: "#ff6b00",
                                fontSize: 13,
                              }}
                            >
                              {filteredLocations?.length}
                            </span>
                            {/* <small style={{ color: "#8898aa" }}>
                              {t("Licenses active")}
                            </small> */}
                            )
                          </p>
                          <div className="d-flex align-items-center flex-wrap gap-2">
                            {branchsPermissions.create && (
                              <>
                                <span
                                  id={ADD_BRANCH_BTN_WRAPPER_ID}
                                  className="d-inline-block mx-2"
                                  style={
                                    branchLimitReached
                                      ? { cursor: "not-allowed" }
                                      : undefined
                                  }
                                >
                                  <Button
                                    onClick={handleAddBranch}
                                    color="success"
                                    disabled={branchLimitReached}
                                    style={
                                      branchLimitReached
                                        ? { pointerEvents: "none" }
                                        : undefined
                                    }
                                  >
                                    {t("Add Branch")}
                                  </Button>
                                </span>
                                {branchLimitReached && (
                                  <UncontrolledTooltip
                                    placement="bottom"
                                    target={ADD_BRANCH_BTN_WRAPPER_ID}
                                    trigger="hover focus click"
                                  >
                                    {branchLimitMessage}
                                  </UncontrolledTooltip>
                                )}
                              </>
                            )}

                            {branchsPermissions.edit &&
                              branchSubPermissions?.edit_opening_hours
                                ?.isEnabled && (
                                <Button
                                  onClick={toggle}
                                  className="mx-2"
                                  color="success"
                                >
                                  {t("Update Opening Hours")}
                                </Button>
                              )}

                            <DataExportDropdown
                              onDownloadCSV={exportToCSV}
                              onDownloadExcel={handleExcelDownload}
                              isExportData={loading ? false : true}
                            />
                          </div>
                        </CardTitle>

                        <div className="position-relative w-100">
                          <Form>
                            <Row className="mb-3 mt-3 pb-3 border-bottom">
                              <Col xl={5}>
                                <div className="filter-search-field">
                                  <i
                                    className="bx bx-search-alt-2 filter-search-icon"
                                    aria-hidden="true"
                                  />
                                  <input
                                    type="text"
                                    value={searchTerm}
                                    className="form-control filter-search-input"
                                    placeholder={t("Name")}
                                    onChange={handleSearchChange}
                                  />
                                </div>
                              </Col>
                              <Col xl={5}>
                                <select
                                  className="form-select"
                                  value={status}
                                  onChange={e =>
                                    handleStatusFilter(e.target.value)
                                  }
                                >
                                  <option value={2}>{t("All")}</option>
                                  <option value={1}>{t("Active")}</option>
                                  <option value={0}>{t("Inactive")}</option>
                                </select>
                              </Col>
                              <Col
                                xs={2}
                                className="d-flex align-items-center justify-content-start"
                              >
                                <Button
                                  color="success"
                                  onClick={handleReset}
                                  disabled={loading}
                                  className="g_center d-flex btn-light w-100"
                                  style={{
                                    minWidth: 40,
                                    height: 39,
                                    padding: "0 10px",
                                  }}
                                >
                                  <i
                                    className="mdi mdi-refresh mx-1"
                                    style={{ fontSize: 22 }}
                                  ></i>{" "}
                                  {t("Reset")}
                                </Button>
                              </Col>
                            </Row>
                          </Form>
                          <div
                            className="location_inner mt-2"
                            // style={{ paddingTop: 50 }}
                          >
                            {filteredLocations &&
                            filteredLocations.length === 0 ? (
                              <p className="text-center my-3">
                                {t("No branches found")}
                              </p>
                            ) : (
                              <Table className="table mb-0 " hover>
                                <thead className="table-light full_th">
                                  <tr>
                                    <th>
                                      <span className=" d-inline-block py-2">
                                        {t("S. No.")}
                                      </span>
                                    </th>
                                    <th>
                                      <span className=" d-inline-block py-2">
                                        {t("Image")}
                                      </span>
                                    </th>
                                    <th>
                                      <span className=" d-inline-block py-2">
                                        {t("Name")}
                                      </span>
                                    </th>
                                    <th>
                                      <span className=" d-inline-block py-2">
                                        {t("Branch Reference")}
                                      </span>
                                    </th>
                                    <th>
                                      <span className=" d-inline-block py-2">
                                        {t("Country")}
                                      </span>
                                    </th>
                                    <th>
                                      <span className=" d-inline-block py-2">
                                        {t("Region")}
                                      </span>
                                    </th>
                                    <th>
                                      <span className=" d-inline-block py-2">
                                        {t("City")}
                                      </span>
                                    </th>
                                    <th>
                                      <span className=" d-inline-block py-2">
                                        {t("Address")}
                                      </span>
                                    </th>
                                    <th>
                                      <span className=" d-inline-block py-2">
                                        {t("Remark")}
                                      </span>
                                    </th>

                                    <th>
                                      <span className=" d-inline-block py-2">
                                        {t("Status")}
                                      </span>
                                    </th>

                                    <th className="text-end">
                                      <span
                                        className="d-inline-block py-2"
                                        style={{ paddingRight: 12 }}
                                      >
                                        {t("Action")}
                                      </span>
                                    </th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {filteredLocations.map((branch, index) => (
                                    <tr
                                      key={branch._id}
                                      onClick={() =>
                                        navigate(
                                          `/branches/branch-details?id=${branch._id}`
                                        )
                                      }
                                      className="cursor-pointer"
                                    >
                                      {/* <td>{index + 1}</td> */}
                                      <td>
                                        {(currentPage - 1) * itemsPerPage +
                                          index +
                                          1}
                                      </td>
                                      <td>
                                        <img
                                          width={50}
                                          height={50}
                                          src={
                                            branch.imageUrl
                                              ? branch.imageUrl
                                              : placeholderImage
                                          }
                                          style={{ objectFit: "contain" }}
                                        />
                                      </td>
                                      <td>
                                        <p style={{ maxWidth: 150 }}>
                                          {language === "sa"
                                            ? branch.nameAr
                                            : branch.name}
                                        </p>
                                      </td>
                                      <td>
                                        <p>{branch.branchId}</p>
                                      </td>
                                      <td>
                                        {language === "sa"
                                          ? branch?.countryId?.nameAr || "-"
                                          : branch?.countryId?.name || "-"}
                                      </td>
                                      <td>
                                        {language === "sa"
                                          ? branch?.regionId?.nameAr || "-"
                                          : branch?.regionId?.name || "-"}
                                      </td>
                                      <td>
                                        {language === "sa"
                                          ? branch?.cityId?.nameAr || "-"
                                          : branch?.cityId?.name || "-"}
                                      </td>
                                      <td style={{ minWidth: 180 }}>
                                        {language === "sa"
                                          ? branch.addressAr || "-"
                                          : branch.address || "-"}
                                      </td>
                                      <td>{branch.remark || "-"}</td>
                                      <td>
                                        {branch.status === 1 ? (
                                          <Badge className="bg-success">
                                            {t("Active")}
                                          </Badge>
                                        ) : (
                                          <Badge className="bg-danger">
                                            {t("Inactive")}
                                          </Badge>
                                        )}
                                      </td>
                                      <td>
                                        <div
                                          className="right d-flex align-items-center justify-content-end gap-3"
                                          style={{ marginRight: 10 }}
                                        >
                                          {branchsPermissions.edit &&
                                            branch._id && (
                                              <>
                                                <i
                                                  id={"edit_icon" + branch._id}
                                                  className="mdi mdi-pencil font-size-18 text-success cursor-pointer"
                                                  onClick={e => {
                                                    e.stopPropagation()
                                                    handleEditBranch(branch._id)
                                                  }}
                                                  title={t("Edit")}
                                                ></i>
                                                {/* {!isLoading && branch?._id && (
                                                  <UncontrolledTooltip
                                                    placement="bottom"
                                                    target={
                                                      "edit_icon" + branch._id
                                                    }
                                                  >
                                                    {t("Edit")}
                                                  </UncontrolledTooltip>
                                                )} */}
                                              </>
                                            )}

                                          {(isTenantOwnerAdmin() ||
                                            (branchsPermissions.edit &&
                                              branchSubPermissions?.clone_branch
                                                ?.isEnabled &&
                                              branch._id)) && (
                                            <>
                                              <i
                                                onClick={e => {
                                                  e.stopPropagation()
                                                  handleCloneBranchClick(branch._id)
                                                }}
                                                id={`clonetooltip_${branch._id}`}
                                                className="bx bx-copy font-size-18 text-primary mx-2 cursor-pointer"
                                                title={t("Clone")}
                                              ></i>
                                              {/* {!isLoading && branch?._id && (
                                                  <UncontrolledTooltip
                                                    placement="top"
                                                    target={`clonetooltip_${branch._id}`}
                                                  >
                                                    {t("Clone")}
                                                  </UncontrolledTooltip>
                                                )} */}
                                            </>
                                          )}
                                          {branch._id && (
                                            <>
                                              <i
                                                id={"view_icon" + branch._id}
                                                onClick={e => {
                                                  e.stopPropagation()
                                                  navigate(
                                                    `/branches/branch-details?id=${branch._id}`
                                                  )
                                                }}
                                                title={t("View")}
                                                className="mdi mdi-eye font-size-18 cursor-pointer"
                                              />
                                              {/* {!isLoading && branch?._id && (
                                                <UncontrolledTooltip
                                                  placement="bottom"
                                                  target={
                                                    "view_icon" + branch._id
                                                  }
                                                >
                                                  {t("View")}
                                                </UncontrolledTooltip>
                                              )} */}
                                            </>
                                          )}
                                          {branchsPermissions.edit &&
                                            branchSubPermissions
                                              ?.edit_branch_status?.isEnabled &&
                                            branch._id && (
                                              <Switch
                                                onClickHandler={e => {
                                                  e.stopPropagation()
                                                  setBranchToUpdate(branch) // store branch info
                                                  setShowConfirmModal(true) // open confirm modal
                                                }}
                                                isTitle={t("Status")}
                                                isChecked={branch.status === 1}
                                                disabled={
                                                  branch._id === selectedId &&
                                                  isUpdating
                                                }
                                              />
                                            )}
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                            )}
                          </div>
                        </div>
                      </Col>
                      {!loading &&
                        filteredLocations &&
                        filteredLocations?.length > 0 && (
                          <Row>
                            <Col>
                              <Card>
                                <CardBody>
                                  <Paginations
                                    data={filteredLocations}
                                    itemsPerPage={itemsPerPage}
                                    onPageChange={onPageChange}
                                    currentPage={currentPage}
                                    totalPages={totalPages}
                                    totalCount={filteredLocations.length}
                                  />
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                        )}
                    </TabPane>
                    <TabPane tabId="2">
                      <Form>
                        <Row className="mb-3 pb-3 border-bottom">
                          <Col xs={5}>
                            <div className="filter-search-field">
                              <i
                                className="bx bx-search-alt-2 filter-search-icon"
                                aria-hidden="true"
                              />
                              <input
                                type="text"
                                value={searchTerm}
                                className="form-control filter-search-input"
                                placeholder={t("Name")}
                                onChange={handleSearchChange}
                              />
                            </div>
                          </Col>
                          <Col xs={5}>
                            <Select
                              value={selectedLocationId}
                              // isMulti={true}
                              onChange={selectedOption => {
                                setCenter({
                                  lat: selectedOption.latitude,
                                  lng: selectedOption.longitude,
                                })
                                setZoom(10)
                                setSelectedLocationId(selectedOption)
                              }}
                              options={branchsList?.map(item => ({
                                label:
                                  language === "sa" ? item.nameAr : item.name,
                                value: item._id,
                                latitude: item.latitude,
                                longitude: item.longitude,
                              }))}
                              placeholder={t("Select Branches")}
                              className="select2-selection"
                              closeMenuOnSelect={false}
                            />
                          </Col>
                          <Col
                            xs={2}
                            className="d-flex align-items-center justify-content-start"
                          >
                            <Button
                              color="success"
                              className={`g_center d-flex btn-light w-100`}
                              onClick={() => {
                                setSearchTerm("")
                                setZoom(2)
                                setSelectedLocationId(null)
                              }}
                              style={{
                                minWidth: 40,
                                height: 39,
                                padding: "0 10px",
                              }}
                            >
                              <i
                                className="mdi mdi-refresh mx-1"
                                style={{ fontSize: 22 }}
                              ></i>{" "}
                              {t("Reset")}
                            </Button>
                          </Col>
                        </Row>
                      </Form>
                      <Col className="px-0">
                        <div className="d-flex justify-content-end mb-3">
                          <p className="mx-2 mb-0">{t("Show in map:")}</p>
                          <input
                            type="checkbox"
                            checked={showBranch}
                            onClick={handleCheckboxChange}
                          />
                        </div>
                        <div style={{ height: "100vh" }}>
                          <div>
                            <div
                              id="gmaps-markers"
                              className="gmaps"
                              style={{ position: "relative" }}
                            >
                              <Map
                                google={props.google}
                                style={{ width: "100%", height: "100vh" }}
                                zoom={zoom}
                                center={center}
                              >
                                {showBranch &&
                                  filteredLocations.map(
                                    ({
                                      latitude,
                                      longitude,
                                      name,
                                      nameAr,
                                      _id,
                                      cityId,
                                      regionId,
                                      countryId,
                                      address,
                                      addressAr,
                                      openingHours,
                                    }) => {
                                      return (
                                        <Marker
                                          key={_id}
                                          title={name}
                                          name={name}
                                          position={{
                                            lat: latitude,
                                            lng: longitude,
                                          }}
                                          onClick={() => handleMarkerClick(_id)}
                                        >
                                          {activeMarker === _id && (
                                            <InfoWindow
                                              onCloseClick={
                                                handleInfoWindowClose
                                              }
                                              options={{
                                                enableEventPropagation: true,
                                              }}
                                            >
                                              <div
                                                className="p-1"
                                                style={{ maxWidth: 300 }}
                                              >
                                                <h5>
                                                  {language === "sa"
                                                    ? nameAr
                                                    : name}
                                                </h5>
                                                <h6 className="pt-2">
                                                  <span className="font-bold">
                                                    {cityId?.name
                                                      ? `${
                                                          language === "sa"
                                                            ? cityId?.nameAr
                                                            : cityId?.name
                                                        }, `
                                                      : ""}
                                                    {regionId?.name
                                                      ? `${
                                                          language === "sa"
                                                            ? regionId?.nameAr
                                                            : regionId?.name
                                                        }, `
                                                      : ""}
                                                    {language === "sa"
                                                      ? countryId?.nameAr
                                                      : countryId?.name || "-"}
                                                  </span>
                                                </h6>
                                                {address && (
                                                  <h6 className="pt-3">
                                                    {t("Address")}:{" "}
                                                    {address || "-"}
                                                  </h6>
                                                )}
                                                <h6 className="pt-3">
                                                  {t("Branch Timings")}:
                                                </h6>
                                                <Table className="table-nowrap mb-0 branch_window_table">
                                                  <thead>
                                                    <tr>
                                                      <td>
                                                        <b>
                                                          {t("Day Of Week")}
                                                        </b>
                                                      </td>
                                                      <td>
                                                        <b>
                                                          {t("Opening Time")}
                                                        </b>
                                                      </td>
                                                      <td>
                                                        <b>
                                                          {t("Closing Time")}
                                                        </b>
                                                      </td>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    {openingHours?.map(item => (
                                                      <tr key={item._id}>
                                                        <td>
                                                          {t(item?.dayOfWeek)}
                                                        </td>
                                                        {item.closed ? (
                                                          <td colSpan="2">
                                                            {t("Closed")}
                                                          </td>
                                                        ) : (
                                                          <>
                                                            <td>
                                                              {convertToAMPM(
                                                                item?.openingTime
                                                              )}
                                                            </td>
                                                            <td>
                                                              {convertToAMPM(
                                                                item?.closingTime
                                                              )}
                                                            </td>
                                                          </>
                                                        )}
                                                      </tr>
                                                    ))}
                                                  </tbody>
                                                </Table>
                                              </div>
                                            </InfoWindow>
                                          )}
                                        </Marker>
                                      )
                                    }
                                  )}
                              </Map>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </TabPane>
                  </TabContent>
                </Row>
              </CardBody>
            </Card>
          )}
        </div>
      </div>
      <DeleteModal
        show={showDeleteModal}
        onDeleteClick={handleDelete}
        onCloseClick={() => setShowDeleteModal(false)}
        buttonText={t("Delete")}
        isLoading={isLoading}
        bodyTitle={t("Are you sure you want to delete this {{name}}?", {
          name: t("Branch"),
        })}
      />
      <ConfirmModal
        show={showConfirmModal}
        onDeleteClick={() => {
          if (branchToUpdate) {
            handleEnableBranch(branchToUpdate._id, branchToUpdate.status)
            setShowConfirmModal(false)
          }
        }}
        onCloseClick={() => setShowConfirmModal(false)}
        isLoading={isUpdating}
        buttonText={t("Yes")}
        bodyTitle={t("Are you sure you want to update the status?")}
      />

      <Modal isOpen={modal} toggle={toggle} size="lg">
        <UpdateOpeningHours toggle={toggle} t={t} language={language} />
      </Modal>
      <Modal isOpen={cloneModal} toggle={toggleCloneModal}>
        <CloneBranch
          toggleCloneModal={toggleCloneModal}
          t={t}
          cloneBranchId={cloneBranchId}
          isLoading={isLoading}
        />
      </Modal>
    </React.Fragment>
  )
}

MapsGoogle.propTypes = {
  google: PropTypes.object,
}

export default connect(
  null,
  {}
)(
  GoogleApiWrapper({
    apiKey: googleAPIKeys,
    LoadingContainer: LoadingContainer,
    v: "3",
  })(MapsGoogle)
)
